export default {
    load: false,
    type: 'Custom',
    col: 10,
    columns: [],
    heightFixed: false,
    height: 400,
    defaultFilter: '',
    search: false,
    filters:[],
    opened: {
        searchAdd: false,
        searchEdit: false,
        searchAddPay: false,
        formAddPay: true,
        formEditRegular: true,
        formEditPay: true,
        list: [
            {
                label: 'Поиск',
                type: 'label',
                field: '1'
            },
            {
                label: 'Добавление счёта',
                type: 'switch',
                field: 'searchAdd'
            },
            {
                label: 'Редактирование счёта',
                type: 'switch',
                field: 'searchEdit'
            },
            {
                label: 'Добавление требования на оплату',
                type: 'switch',
                field: 'searchAddPay'
            },
            {
                label: 'Форма счета',
                type: 'label',
                field: '2'
            },
            {
                label: 'Оплата требования на оплату',
                type: 'switch',
                field: 'formAddPay'
            },
            {
                label: 'Редактирование требования на оплату',
                type: 'switch',
                field: 'formEditRegular'
            },
            {
                label: 'Редактирование платежа',
                type: 'switch',
                field: 'formEditPay'
            },
        ]
    },
    data: null,


    filter: '',
    visible: false,
    rebind: true,
}